import { createFileRoute } from "@tanstack/react-router";
import { SwapPage } from "../../features/swap/pages/swap-page";

export const Route = createFileRoute("/_layout/swap")({
  component: SwapPage,
});
